import { axios } from "utils";

import { ADMIN_SOIL_SIGHT_URL } from "consts";

import { SilverServiceVersion, VersionReview } from "models";

export const listSilverVersions = async (): Promise<SilverServiceVersion[]> => axios.get(`${ADMIN_SOIL_SIGHT_URL}/silver-versions`);

export const createVersionReview = async (body: {
  baselineVersion: string;
  candidateVersion: string;
  score: number;
  comment?: string | null;
}): Promise<{ id: string }> => axios.post(`${ADMIN_SOIL_SIGHT_URL}/silver-versions/reviews`, body);

export const listVersionReviews = async (): Promise<VersionReview[]> => axios.get(`${ADMIN_SOIL_SIGHT_URL}/silver-versions/reviews`);
